export default {"src":"/_next/static/media/upflow-logo.6b23a66b.svg","height":90,"width":130};